export default __webpack_public_path__ + "static/media/carrivnav.817da3f0.svg";